function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.292 5.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M105.904 144.6v3.704c0 .145-.119.264-.264.264a2.12 2.12 0 0 1-2.117-2.116 2.12 2.12 0 0 1 2.117-2.117c.145 0 .264.12.264.265m2.646 2.116h-1.852a.265.265 0 0 0-.264.265v1.852c0 .145.119.265.264.265a2.12 2.12 0 0 0 2.117-2.117.265.265 0 0 0-.265-.265m-1.852-.529h1.852c.146 0 .265-.119.265-.264a2.12 2.12 0 0 0-2.117-2.117.265.265 0 0 0-.264.264v1.853c0 .145.119.264.264.264",
    style: {
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    transform: "translate(-103.523 -143.806)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.8c3d373a8c1bf118ab0aba749b511ac0.svg";
export { ForwardRef as ReactComponent };